import { useTranslation } from 'react-i18next';
import { Notice } from './Controls.tsx';

/** Shows an error by its stable code (`platform.errors.<code>`); unknown errors fall back to `internal`. */
export function ErrorAlert({ error }: { error: unknown }) {
    const { t, i18n } = useTranslation();
    const code =
        typeof error === 'object' && error !== null && 'code' in error && typeof error.code === 'string'
            ? error.code
            : 'internal';
    const key = i18n.exists(`platform.errors.${code}`) ? `platform.errors.${code}` : 'platform.errors.internal';
    return <FormError message={t(key)} />;
}

/** Validation or submission feedback that cannot be attached to a specific field. */
export function FormError({ message }: { message: string | undefined }) {
    return message ? <Notice tone="danger">{message}</Notice> : null;
}
